module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Sumários Executivos'
    }
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Sumários Executivos")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Sumários Executivos',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaSumarioExecutivo"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lista de Sumários Executivos "), (!_vm.loading.tela) ? _c('span', {
    staticClass: "info_discreto"
  }, [_vm._v(_vm._s(_vm.tabelaSumarioExecutivo.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'edita-sumario-executivo',
          params: {
            id: null
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Sumário ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": _vm.ajustaPesquisa,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.tabelaSumarioExecutivo.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tabelaSumarioExecutivo.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: 'tabelaDetalhe',
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "hover": "",
      "bordered": _vm.tabelaSumarioExecutivo.bordered,
      "items": _vm.sumarios,
      "fields": _vm.camposSumarioExecutivo,
      "filter": _vm.tabelaSumarioExecutivo.filter,
      "filter-function": _vm.filtroPorItem,
      "current-page": _vm.tabelaSumarioExecutivo.currentPage,
      "per-page": _vm.tabelaSumarioExecutivo.perPage,
      "sort-by": _vm.tabelaSumarioExecutivo.sortBy,
      "sort-desc": _vm.tabelaSumarioExecutivo.sortDesc,
      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tabelaSumarioExecutivo, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function(row) {
        return [_vm._v("\n                      " + _vm._s(row.value) + "\n                    ")]
      }
    }, {
      key: "sumario.acao",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'top',
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
          }],
          staticClass: "link_acesso",
          attrs: {
            "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
          },
          on: {
            "click": function($event) {
              return _vm.copiaUrl(row)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(row.value) + "\n                        "), (_vm._.has(row.item, 'link_copia')) ? _c('span', {
          class: _vm._.get(row.item, 'link_copia.classe')
        }, [_vm._v(_vm._s(_vm._.get(row.item, 'link_copia.msg')))]) : _vm._e()])]
      }
    }, {
      key: "sumario.data",
      fn: function(row) {
        return [_vm._v("\n                      " + _vm._s(_vm.moment(row.item.sumario.data).add(1, 'day').format('DD/MM/YYYY')) + "\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(row.item.sumario.inicio) + " até " + _vm._s(row.item.sumario.termino) + "\n                    ")]
      }
    }, {
      key: "sumario.local",
      fn: function(row) {
        return [_vm._v("\n                      " + _vm._s(row.item.sumario.local) + "\n                    ")]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-sumario-executivo',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-sumario-executivo',
                params: {
                  id: row.item.id,
                  visualizacao: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Visualizar")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.duplicarSumario(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Duplicar")])]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tabelaSumarioExecutivo.totalRows,
      "per-page": _vm.tabelaSumarioExecutivo.perPage
    },
    model: {
      value: (_vm.tabelaSumarioExecutivo.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tabelaSumarioExecutivo, "currentPage", $$v)
      },
      expression: "tabelaSumarioExecutivo.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43213384!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/sumarioExecutivo/ListaSumarioExecutivo.vue
// module id = 1874
// module chunks = 2